/* oxlint-disable @typescript-eslint/no-explicit-any */
/* oxlint-disable @typescript-eslint/no-use-before-define */

import { useState } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';

import { checkAxiosError } from '@flipster/utils/axios';
import { getErrorCode } from '@flipster/utils/error';

import { isPasskeySupported } from './core';

export function usePasskeySupported() {
  const [supported, setSupported] = useState(false);
  useIsomorphicLayoutEffect(() => {
    setSupported(isPasskeySupported());
  }, []);
  return supported;
}

export function getPasskeyErrorMessage(error: any): string {
  if (checkAxiosError(error)) {
    switch (getErrorCode(error)) {
      case 'api.user.passkey.credentialMaxCountExceeded':
        return 'You have reached the maximum limit of 10 passkeys. To add a new passkey, please delete an existing one.';
      case 'api.user.passkey.verificationError':
        return 'Authentication is invalid. Please try again or try another method.';
      default:
        break;
    }
  }
  if ('name' in error) {
    switch (error.name) {
      case 'NotAllowedError':
        return 'Authentication was canceled or timed out. Please try again.';
      case 'InvalidStateError':
        return 'A Passkey is already registered. Duplicate registration is not allowed.';
      case 'SecurityError':
        return 'A security error occurred. Please check the RP ID or try in an HTTPS environment.';
      case 'TypeError':
        return 'Authentication is invalid. Please try again or try another method.';
      case 'AbortError':
        return 'The authentication process was aborted. Check your network and try again.';
      default:
        return 'An unknown error occurred. Please try on a different device or browser.';
    }
  }
  return 'An unknown error occurred. Please try on a different device or browser.';
}
